import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface TopWorkplaceRowProps {
  workplace: string;
  index: number;
}

// eslint-disable-next-line no-restricted-syntax
const WORKPLACE_INDEX_COLOR = "#E66156";

export function TopWorkplaceRow(props: TopWorkplaceRowProps) {
  const { workplace, index } = props;

  return (
    <Stack key={workplace} direction="row" spacing={1} sx={{ position: "relative", zIndex: 1 }}>
      <Text semibold variant="h4" sx={{ color: WORKPLACE_INDEX_COLOR, width: "2ch" }}>
        #{index + 1}
      </Text>

      <Text variant="h4" sx={(theme) => ({ color: theme.palette.text.secondary })}>
        {workplace}
      </Text>
    </Stack>
  );
}
